'use client';

import type { CSSProperties } from 'react';
import { BlockRoot, tx } from '@akademi/site-builder-runtime';

type Localized = string | Record<string, string>;
export interface SolarTrustFigure { value: Localized; label: Localized; note?: Localized; }
export interface SolarTrustFiguresProps { title?: Localized; figures?: SolarTrustFigure[]; }

const DEFAULT_FIGURES: SolarTrustFigure[] = [
  { value: '[confirm]', label: 'systems designed', note: '[confirm]' },
  { value: '[confirm]', label: 'years of product guarantee', note: '[confirm]' },
  { value: '[confirm]', label: 'delivery window', note: '[confirm]' },
];

export function SolarTrustFigures({ title = 'The details matter', figures = DEFAULT_FIGURES }: SolarTrustFiguresProps) {
  return (
    <BlockRoot as="section" style={sectionStyle}>
      <div style={innerStyle}>
        {title && <h2 style={titleStyle}>{tx(title)}</h2>}
        <div style={gridStyle}>
          {figures.map((figure, index) => <div key={index} style={figureStyle}><strong style={valueStyle}>{tx(figure.value)}</strong><span style={labelStyle}>{tx(figure.label)}</span>{figure.note && <small style={noteStyle}>{tx(figure.note)}</small>}</div>)}
        </div>
      </div>
    </BlockRoot>
  );
}
const sectionStyle: CSSProperties = { padding: 'clamp(40px, 7vw, 80px) var(--space-6, 24px)', background: 'var(--color-surface-page, #fff)' };
const innerStyle: CSSProperties = { maxWidth: 1180, margin: '0 auto' };
const titleStyle: CSSProperties = { margin: '0 0 28px', fontSize: 'clamp(24px, 3vw, 36px)', textAlign: 'center' };
const gridStyle: CSSProperties = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 1, border: '1px solid var(--color-border-default, #cbd5e1)', borderRadius: 'var(--radius-lg, 12px)', overflow: 'hidden' };
const figureStyle: CSSProperties = { display: 'flex', flexDirection: 'column', gap: 6, padding: '28px 20px', textAlign: 'center', background: 'var(--color-surface-subtle, #f8fafc)' };
const valueStyle: CSSProperties = { fontSize: 'clamp(24px, 4vw, 40px)', color: 'var(--color-brand-700, #1d4ed8)' };
const labelStyle: CSSProperties = { fontWeight: 700 };
const noteStyle: CSSProperties = { color: 'var(--color-text-secondary, #475569)' };
